import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCrsfToken } from '~/hooks/useCrsfToken'
import { PasswordResetBadRequest } from '../types'

export const usePasswordReset = () => {
    const queryClient = useQueryClient()
    const csrfToken = useCrsfToken()

    return useMutation<unknown, PasswordResetBadRequest, unknown>({
        mutationFn: async ({ email }) => {
            const form = new FormData()
            form.append('email', email)

            const resp = await fetch('/api/account/password/reset-request', {
                method: 'POST',
                headers: {
                    'X-CSRFToken': csrfToken,
                },
                body: form,
            })
            if (resp.status >= 500) {
                try {
                    return await resp.json()
                } catch (e) {
                    throw { __all__: [{ message: 'Internal server error', code: 'server_error' }] }
                }
            }
            if (resp.status === 400) {
                throw await resp.json()
            }
        },
        onSuccess: () => {
            return queryClient.invalidateQueries(['viewer'])
        },
    })
}
